'use client';

import { useTranslations } from 'next-intl';
import { Box } from '@terra/ui-styled-system';
import { Text } from '../../../components/styled/text';
import { finishedAgentDisplayName } from './background-update-agent';
import {
  CHAT_STEP_LABEL_COLOR,
  CHAT_STEP_LABEL_SIZE,
  CHAT_STEP_MIN_HEIGHT,
} from './chat-nesting-layout';

export function BackgroundUpdateSeparator({
  agentType,
  stopped = false,
}: {
  agentType: string;
  stopped?: boolean;
}) {
  const t = useTranslations('designSystem.chat');
  const agent = finishedAgentDisplayName(agentType);

  return (
    <Box display="flex" alignItems="center" minHeight={CHAT_STEP_MIN_HEIGHT}>
      <Text
        fontSize={CHAT_STEP_LABEL_SIZE}
        fontWeight="400"
        color={CHAT_STEP_LABEL_COLOR}
      >
        {t(stopped ? 'subagentStopped' : 'subagentFinished', { agent })}
      </Text>
    </Box>
  );
}
